module.exports = __webpack_public_path__ + "static/media/spark.6556643f.png";